import api from 'api/api'
import useStore from 'state/knovStore'
import { consumeSpaceNotificationBadge } from 'refactor/hooks/api/notificationBadgeRefetchPolicy'

export const clearNotificationCount = () => {
    const { activeSpaceId } = useStore.getState()

    // because notification count is coupled to the filter system we have to do a pointless call
    // to getQuests to actually clear it
    return api
        .getQuests({
            notifications: true,
            space_id: activeSpaceId,
            clear: true,
        })
        .then(() => {
            // update the client side notification count, per-space count included
            useStore.getState().set(state => consumeSpaceNotificationBadge(state, activeSpaceId))
        })
        .catch(error => {
            console.error("couldn't reset notification count", error)
        })
}
